import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const defEvents = {
    before: AppConstants.GOAL_ACTIONS_START_LOADING,
    success: AppConstants.GOAL_ACTIONS_SEARCH_SUCCESS,
    fail: AppConstants.GOAL_ACTIONS_SEARCH_FAIL
};

const normalizeIds = (value) => {
    if (!value) {
        return [];
    }

    return String(value)
        .split(',')
        .map(id => (id || '').toString().trim())
        .filter(id => id && !isNaN(id) && parseInt(id, 10) > 0);
};

const GoalActions = {
    getListGoalActions(params, callback, events = defEvents) {
        if (!params) {
            return;
        }

        const normalizedGoalIds = normalizeIds(params.goal_ids);
        const normalizedIds = normalizeIds(params.ids);

        if (!normalizedGoalIds.length && !normalizedIds.length) {
            return;
        }

        const validatedParams = {
            ...params
        };

        if (normalizedGoalIds.length) {
            validatedParams.goal_ids = normalizedGoalIds.join(',');
        } else {
            delete validatedParams.goal_ids;
        }

        if (normalizedIds.length) {
            validatedParams.ids = normalizedIds.join(',');
        } else {
            delete validatedParams.ids;
        }

        events.before && dispatch({
            type: events.before
        });

        api.searchGoalActions({
            page: 1,
            count: 1000,
            sort: 'action.name',
            order: 'asc',
            ...validatedParams
        })
            .then(data => {
                events.success && dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    if (events.fail) {
                        dispatch({
                            type  : events.fail,
                            error : err
                        });
                    }
                });
            });
    },

    clear() {
        dispatch({
            type: AppConstants.GOAL_ACTIONS_CLEAR
        });
    }
};

export default GoalActions;
